export const SUBJECTS_COMPETENCES = "/api/subjects-competences"
export const SUBJECT_COMPETENCE_DISABLE = "/api/subjects-competences/:param/desactivate"
export const SUBJECT_COMPETENCE_ENABLE = "/api/subjects-competences/:param/activate"
export const SUBJECT_COMPETENCE = "/api/subjects-competences/:param"